import React from "react";

export default function Error() {
  return (
    <div className="pt-[40%] min-h-[100vh] mi-w-[1240px]">
      <h1 className="text-5xl font-bold">Error 404! Page not found</h1>
    </div>
  );
}
